// languages/korean.js
export const korean = {
  name: "한국어",
  interface: {
    welcome: "환영합니다",
    chooseLanguage: "언어 선택",
    continue: "계속",
    backToMap: "지도로 돌아가기",
    achievement: "성과",
    viewInAR: "AR로 보기",
    menu: {
      menu: "메뉴",
      home: "홈",
      language: "언어",
      achievement: "업적",
      unsuiExperience: "운수이 체험",
      feedback: "피드백",
    },
    buyScreen: {
      clickToBuy: "클릭하여 특별한 절",
      templeExperience: "체험을 구매하세요!",
      description1: "오디오 가이드로 절의 흥미로운",
      description2: "이야기를 듣고 마법",
      description3: "같은 AR을 즐기세요!",
      buy: "구매하기",
    },
    gift: {
      congratulations: "축하합니다!",
      yourGift: "당신의 선물",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
